import React from 'react';
import PropTypes from 'prop-types';

import { Chip } from '@material-ui/core';
import { Overlay } from '../../components/dialog';
import LotteryGifPath from '../../../images/movie.gif';
import PrizeWinner from '../../../images/prizewinner.png';

const maskPhoneNumber = phoneNumber =>
  // 最後の4桁を切り出し
  phoneNumber.length > 0 &&
  phoneNumber.substring(phoneNumber.length - 4, phoneNumber.length);

const dialogStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  WebkitTransform: 'translateY(-50%) translateX(-50%)',
  transform: 'translateY(-50%) translateX(-50%)',
  padding: '20px',
};

function LotteryAnimation(props) {
  return (
    <Overlay show={props.showAnimation}>
      <div style={dialogStyle}>
        {props.pending && <img src={LotteryGifPath} alt={'抽選'} />}
        {!props.pending && (
          <div>
            <img src={PrizeWinner} alt={'当選おめでとう'} />
            <div className="winnerList">
              {props.lastWinners &&
                props.lastWinners.size > 0 &&
                props.lastWinners.map((w, i) => (
                  <Chip
                    key={i}
                    style={{ margin: 4 }}
                    label={maskPhoneNumber(w)}
                  />
                ))}
            </div>
          </div>
        )}
      </div>
    </Overlay>
  );
}

LotteryAnimation.propTypes = {
  showAnimation: PropTypes.bool.isRequired,
  pending: PropTypes.bool.isRequired,
  lastWinners: PropTypes.object.isRequired,
};

export default LotteryAnimation;



// WEBPACK FOOTER //
// ./src/views/pages/lottery/LotteryAnimation.js